<template>
    <v-app id="home">
        <v-overlay :value="process" absolute opacity=0.9 color="white">
                <img
                    src="../assets/images/logo anim.svg"
                    width="100px"
                    height="100px"
                />
        </v-overlay>
        <!-- <h4 class="text-right">
      aawaaz Dashboard
        </h4>-->
        <v-container fluid :style="[!$vuetify.breakpoint.xs ? {'padding':'50px 50px'} : {'padding':'30px 30px 30px'}]">
            <v-row>
                <v-col style="color:black;text-align:right;">
                    <h3>
                        Welcome,
                        <br />
                        {{userProfile.name}}
                    </h3>
                </v-col>
            </v-row>
            <v-row align="center">
                <!-- <v-col :cols="4">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                style="background: transparent; border-radius: 20px 20px 20px 20px;"
                :elevation="hover ? 20 : 6"
                class="pa-5 transition-swing"
                height="300"
                width="auto"
              >
                <v-card-text>
                  <h4 class="py-12" style="color:black">
                    Welcome, <br />
                    {{ userProfile.name }}
                  </h4>
                </v-card-text>
              </v-card>
            </template>
          </v-hover>
                </v-col>-->
                <v-col>
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                style="overflow-y:scroll;background-image: linear-gradient(-45deg, #B7F8DB 0%, #50A7C2 100%); border-radius: 20px 20px 20px 20px; color:white;"
                                :elevation="hover ? 20 : 6"
                                class="pa-2 transition-swing"
                                height="300"
                                width="auto"
                            >
                                <v-card-title class="headline font-weight-bold">
                                    <v-icon
                                        color="white"
                                        style="opacity: 0.6;"
                                        medium
                                        left
                                    >mdi-account-group</v-icon>Classrooms
                                </v-card-title>

                                <v-divider
                                    color="white"
                                    style="margin-top:0; margin-bottom:0; opacity:0.2"
                                ></v-divider>

                                <v-list-item-group v-if="!noclass || !noOldClass">
                                    <v-list-item
                                        v-for="classroom in userProfile.classes"
                                        v-bind:key="classroom"
                                        :to="/classroom/+classroom"
                                        style='color:white !important; text-decoration:none;'
                                    >{{ classroom }}</v-list-item>
                                    <v-list-item
                                        class="old-class-head"
                                        v-if="!noOldClass"
                                        @click="showOldClass = !showOldClass"
                                        style='color:white !important;'
                                    >
                                        <v-icon
                                        color="white"
                                        style="opacity: 0.6;"
                                        :class="['show-icon', showOldClass ? 'rotated' : '']"
                                    >mdi-chevron-right</v-icon>
                                        <span style="padding-left:10px">Show inactive classes</span>
                                    </v-list-item>
                                    <span v-if="showOldClass">
                                        <v-list-item
                                            v-for="classroom in userProfile.oldClasses"
                                            :key="classroom"
                                            :to="/classroom/+classroom"
                                            style="padding-left:45px;color:white !important; text-decoration:none;"
                                        >{{ classroom }}</v-list-item>
                                    </span>
                                </v-list-item-group>

                                <v-list-item-group v-else>
                                    <v-list-item
                                        style="color:white !important;"
                                    >You are not part of any classes.</v-list-item>
                                </v-list-item-group>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col :cols='m'>
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                style="overflow-y:scroll;background-image: linear-gradient(-45deg, #FFC796 0%, #FF6B95 100%); border-radius: 20px 20px 20px 20px; color:white;"
                                :elevation="hover ? 24 : 6"
                                class="pa-2 transition-swing"
                                height="220"
                                width="auto"
                            >
                                <v-card-title class="headline font-weight-bold">
                                    <v-icon color="white" style="opacity: 0.6;" medium left>mdi-bell</v-icon>Notifications
                                </v-card-title>

                                <v-divider
                                    color="white"
                                    style="margin-top:0; margin-bottom:0; opacity:0.2"
                                ></v-divider>

                                <v-list-item-group v-if="dueCount || newRepCount || msgCount">
                                    <v-list-item
                                        style="color:white !important; text-decoration:none;"
                                        v-if="dueCount"
                                        to="/assignments"
                                    >
                                        You have {{dueCount}} {{dueCount==1 ? 'assignment' : 'assignments'}} due.
                                    </v-list-item>
                                    <v-list-item
                                        style="color:white !important; text-decoration:none;"
                                        v-if="newRepCount"
                                        to="/reports"
                                    >
                                        You have {{ `${newRepCount} unread` }} {{newRepCount==1 ? 'report.' : 'reports.'}}
                                    </v-list-item>
                                    <v-list-item
                                        style="color:white !important; text-decoration:none;"
                                        v-if="msgCount"
                                        to="/chat"
                                    >
                                        You have unread messages from {{ msgCount}} {{ msgCount==1 ? 'chat.' : 'chats.' }}
                                    </v-list-item>
                                </v-list-item-group>
                                <v-list-item-group v-else>
                                    <v-list-item
                                        style="color:white !important;"
                                    >No new notifications.</v-list-item>
                                </v-list-item-group>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>
                <v-col :cols="m">
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                style="overflow-y:scroll;background-image: linear-gradient(45deg, #7028e4 0%, #e5b2ca 100%); border-radius: 20px 20px 20px 20px; color:white;"
                                :elevation="hover ? 20 : 6"
                                class="pa-2 transition-swing"
                                height="220"
                                width="auto"
                            >
                                <v-card-title class="headline font-weight-bold">
                                    <v-icon
                                        color="white"
                                        style="opacity: 0.6;"
                                        medium
                                        left
                                    >mdi-bullhorn</v-icon>Announcements
                                </v-card-title>

                                <v-divider
                                    color="white"
                                    style="margin-top:0; margin-bottom:0; opacity:0.2"
                                ></v-divider>
                                <v-list-item-group v-if="announcements.length">
                                    <v-list-item
                                        flat
                                        v-for="announcement in announcements"
                                        v-bind:key="announcement.text"
                                        style="color:white !important;"
                                    >{{ announcement.text }}</v-list-item>
                                </v-list-item-group>
                                <v-list-item-group v-else>
                                    <v-list-item
                                        style="color:white !important;"
                                    >No announcements</v-list-item>
                                </v-list-item-group>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
// TODO Check if delete report works
import { mapState } from "vuex";
import Vuex from "vuex";
const fb = require("../firebaseConfig.js");

export default {
    data() {
        return {
            announcements: [],
            dueCount: 0,
            msgCount: 0,
            newRepCount: 0,
            noclass: true,
            process: true,
            promises: [],
            notif: false,
            noOldClass: true,
            showOldClass: false
        };
    },
    created: function() {
        Promise.resolve(this.promise).then(() => {
            this.getMsgCount();

            this.getAnn();
            if (!this.teacher) {
                this.getDueCount();
                this.getNewRepCount();
            }
            Promise.all(this.promises).then(() => {
                this.noclass = this.userProfile.classes.length ? false : true;
                this.noOldClass = this.userProfile.oldClasses.length
                    ? false
                    : true;
                this.process = false;
            });
        });
    },
    computed: {
        ...mapState(["userProfile", "promise", "teacher"]),
        m() {
            return this.$vuetify.breakpoint.smAndDown ? 12 : 6
        }
    },
    methods: {
        getAnn() {
            this.promises.push(
                fb.db
                    .collection("announcements")
                    .where("show", "==", true)
                    .orderBy("timestamp", "desc")
                    .get()
                    .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            this.announcements.push(doc.data());
                        });
                    })
            );
        },
        getMsgCount() {
            this.promises.push(
                fb.db
                    .collection("chats")
                    .where("members", "array-contains", this.userProfile.email)
                    .where("recipientRead", "==", false)
                    .get()
                    .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            if (
                                doc.data().lastSender != this.userProfile.email
                            ) {
                                this.notif = true;
                                this.msgCount += 1;
                            }
                        });
                    })
            );
        },
        getDueCount() {
            this.promises.push(
                fb.db
                    .collection("assignments")
                    .where(
                        "yetToSubmit",
                        "array-contains",
                        this.userProfile.email
                    )
                    .where("completed", "==", false)
                    .get()
                    .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            this.notif = true;
                            this.dueCount++;
                        });
                    })
            );
        },
        getNewRepCount() {
            this.promises.push(
                fb.db
                    .collection("reportReceipts")
                    .where("student", "==", this.userProfile.email)
                    .where("read", "==", false)
                    .get()
                    .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            this.notif = true;
                            this.newRepCount++;
                        });
                    })
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.show-icon {
    transition: transform 0.5s;
}
.old-class-head:hover {
    cursor: pointer;
}
.rotated {
    transform: rotate(90deg);
}
.old-class-head:hover .show-icon {
    transform: rotate(90deg);
}
</style>